import { render, staticRenderFns } from "./sub-request-types-category.vue?vue&type=template&id=478c1f82&scoped=true&class=content-border%20row&"
import script from "./sub-request-types-category.vue?vue&type=script&lang=js&"
export * from "./sub-request-types-category.vue?vue&type=script&lang=js&"
import style0 from "./sub-request-types-category.vue?vue&type=style&index=0&id=478c1f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c1f82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTabItem})
